import axios from 'axios'
import React, { useContext, useEffect, useState } from 'react'
import { baseUrl, path } from '../../../constants'
import { appContext } from '../../../Context/appProvider'
import { settingsContext } from '../../../Context/settingsProvider'
import { Oval } from 'react-loader-spinner'
import { api } from '../../../api'

export default function Account() {
  const [profile, setProfile] = useState({})
  const [loading, setLoading] = useState(true)
  const [updating, setUpdating] = useState(false)
  const {token} = useContext(appContext)
  const [profileData, setProfileData] = useState({})
  const {addNotification, t} = useContext(settingsContext)

  useEffect(() => {
    api(path.profile).then(response => {
        setLoading(false)
        let d = response.data
        console.log(d)
        setProfileData({email: d.profile.email, firstName: d.profile.firstName, lastName: d.profile.lastName})
    }).catch(e => {
      console.log(e)
      addNotification('error', 'Something went wrong while fetching data')
      setLoading(false)
    })
  }, [])

  const updateProfile = () => {
    setUpdating(true)
    api(path.profile, {
        method: 'post',
        data: {email: profileData.email, firstName: profileData.firstName, lastName: profileData.lastName}
    }).then(response => {
      if(response.data.success){
        setUpdating(false)
        addNotification('success', 'Your profile successfully updated')
      }
    }).catch(e => {
      addNotification('error', 'Something went wrong while updating profile')
      setUpdating(false)
    })
  }

  return (
    <div className='w-full flex flex-col gap-3 p-3'>
        <p className='text-black text-[15px]'>{t('MY_ACCOUNT')}</p>
        <div className='flex gap-12 '>
        {loading ? (
              <div className='flex flex-col items-center gap-3'>
                  <p className='text-black text-[15px]'>{t('LOADING_PROFILE')}</p>
                  <Oval
                      visible={true}
                      height="30"
                      width="30"
                      color="#198754"
                      ariaLabel="oval-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      strokeWidth={3}
                      />
              </div>
          ) : [
            <div className='flex flex-col gap-3'>
                <input placeholder='First Name' type='text' value={profileData.firstName} onChange={(e) => setProfileData(data => ({...data, firstName: e.target.value}))} className='text-black border-[1px] border-black  w-[400px] max-md:w-[200px] p-2 pl-4'  />
                <input placeholder='Last Name' type='text' value={profileData.lastName} onChange={(e) => setProfileData(data => ({...data, lastName: e.target.value}))} className='text-black border-[1px] border-black  w-[400px] max-md:w-[200px] p-2 pl-4'  />
                <input placeholder='Email' type='email'  value={profileData.email} onChange={(e) => setProfileData(data => ({...data, email: e.target.value}))} className='text-black border-[1px] border-black  w-[400px] max-md:w-[200px] p-2 pl-4'  />
                {/* <input placeholder='Password' type='password' className='text-black border-[1px] border-black  w-[400px] p-2 pl-4'  /> */}
                <button onClick={updateProfile} className='bg-main w-[400px] max-md:w-full text-white text-[20px] flex justify-center items-center p-2'>
                  {updating ?  <Oval
                      visible={true}
                      height="30"
                      width="30"
                      color="#ffffff"
                      ariaLabel="oval-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                      strokeWidth={3}
                      /> : t('UPDATE') }</button>
            </div>,

            // <div className='flex flex-col gap-3'>
            //     <input placeholder='Old Password' type='password' className='text-black border-[1px] border-black  w-[400px] p-2 pl-4'  autoComplete='new-password'/>
            //     <input placeholder='New Password' type='password' className='text-black border-[1px] border-black  w-[400px] p-2 pl-4' autoComplete='new-password' />
            //     <input placeholder='Confirm New Password' type='password' className='text-black border-[1px] border-black  w-[400px] p-2 pl-4' autoComplete='new-password' />
            //     <button className='bg-main w-[400px] text-white text-[20px]  p-2'>Change Password</button>
            // </div>
          ]}
        </div>
    </div>
  )
}
